import moment from 'moment';
import _ from 'lodash';
import { getCustomerOrders } from '../../apis/backend';
import { sendCloudWatchAlert } from '../../utils/applicationError';

export const handleChangeOrderPage = (event, page, component) => {
  component.setState({ page });
};

export const handleChangeReductionPage = (event, reductionPage, component) => {
  component.setState({ reductionPage });
};

export const getOrders = async (component, customerId) => {
  try {
    const allOrders = await getCustomerOrders(customerId);
    const { canceledOrders, pastOrders, orders } = allOrders;
    component.setState({
      currentClientOrders: _.orderBy(
        _.merge(pastOrders, canceledOrders, orders),
        [
          order => {
            return moment(order.date);
          },
          'orderNumber'
        ],
        ['desc', 'desc']
      ).slice(0, 5000)
    });
  } catch (error) {
    sendCloudWatchAlert(`Could not get customers orders ${error}`);
    component.setState({
      currentClientOrders: []
    });
  }
};
